import { render, staticRenderFns } from "./UsageMetricChart.vue?vue&type=template&id=dc823f24&scoped=true"
import script from "./UsageMetricChart.vue?vue&type=script&lang=ts"
export * from "./UsageMetricChart.vue?vue&type=script&lang=ts"
import style0 from "./UsageMetricChart.vue?vue&type=style&index=0&id=dc823f24&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc823f24",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZChart: require('/build/apps/legacy/components/zeal/ZChart/ZChart.vue').default,EmptyChart: require('/build/apps/legacy/components/Common/EmptyChart.vue').default})
